import { TableProps } from 'antd/es/table';

export const mapColumns: TableProps['columns'] = [
  {
    title: 'MATERIAL CODE',
    dataIndex: 'matCode',
    key: 'materialCode',
    ellipsis: false,
  },
  {
    title: 'MATERIAL DESCRIPTION',
    dataIndex: 'materialDescription',
    key: 'matDesc',
    ellipsis: true,
  },
  {
    title: 'UNIT',
    dataIndex: 'unit',
    key: 'unit',
    ellipsis: false,
  },
  {
    title: 'REQUIRED QUANTITY',
    dataIndex: 'reqQty',
    key: 'reqQty',
    ellipsis: false,
  },
  {
    title: 'LPO NO.',
    dataIndex: 'lpoNo',
    key: 'lpoNo',
    ellipsis: false,
    render: (Input: JSX.Element) => {
      return Input;
    },
  },
  {
    title: 'RATE',
    dataIndex: 'rate',
    key: 'rate',
    ellipsis: false,
    render: (Input: JSX.Element) => {
      return Input;
    },
  },
];
